import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "loading-placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      _createVNode(_Transition, {
        name: _ctx.transitionName,
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (!_ctx.isLoading)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, "Загрузка..."))
        ]),
        _: 2
      }, 1032, ["name"])
    ]),
    _: 1
  }))
}